import styled from '@emotion/styled';

export const LayoutContainer = styled.div`
  margin: 0 auto;
  position: relative;
`;
